import BaseViewController from "./base-view-controller";
import {
  CREDIT_CARD_FIELDS,
  FIELD_NAMES,
  FIELD_PARAMS,
  PAYPAL_VALUE,
  SHORTEN_FLOW_PAYMENT_SCREENS,
  TEXT_NOTIFICATION_VALUES
} from "../utils/constants";
import {
  getFieldData,
  getLabeledText,
  paramsIncludes,
  getOtherPhoneNumber
} from "./helpers/field-updates";
import { localizeString } from "../utils/string-utils";
class ConsultationConfirmationViewController extends BaseViewController {
  preprocessScreenData() {
    const { values } = this.appData;
    const cardNumberFieldname = this.appData?.isPulse
      ? "credit_card_value"
      : "cc_info.masked_card_number";
    const { field, index } = getFieldData(
      this.screen.fields,
      cardNumberFieldname
    );

    if (values.hasOwnProperty("cc_info.masked_card_number") && field) {
      const cardNumber = values["cc_info.masked_card_number"];
      field.text =
        cardNumber !== PAYPAL_VALUE
          ? `${field.data?.card_string ?? "XXXX"}${cardNumber?.slice(-4)}`
          : cardNumber;
    } else if (index && index !== -1) {
      this.screen.fields.splice(index, 1);
    }

    this.internationalizeFieldByUrlValues("communication_method");
    this.internationalizeFieldByUrlValues("health_category");

    if (!values.name && values.member) {
      const nameField = this.screen.fields.find(f => f.name === "name");
      if (nameField) {
        nameField.text = `${values.member.first_name || ""} ${
          values.member.last_name || ""
        }`;
      }
    }

    if (this.appData.isPulse) {
      // ***Update Payment block***
      const cardValueField = getFieldData(
        this.screen.fields,
        CREDIT_CARD_FIELDS.creditCardValue
      );
      const updatePaymentLinkField = getFieldData(
        this.screen.fields,
        CREDIT_CARD_FIELDS.updatePaymentLink
      );

      if (cardValueField?.field) {
        const valueParams = cardValueField.field.params;

        if (values[CREDIT_CARD_FIELDS.maskedCardNumber] === PAYPAL_VALUE) {
          cardValueField.field.params = paramsIncludes(
            valueParams,
            PAYPAL_VALUE
          )
            ? valueParams
            : `${valueParams}|${PAYPAL_VALUE}`;
          cardValueField.field.title = " ";
        } else {
          cardValueField.field.params = paramsIncludes(
            valueParams,
            PAYPAL_VALUE
          )
            ? valueParams
                .split("|")
                .filter(param => param !== PAYPAL_VALUE)
                .join("|")
            : valueParams;
        }
      }

      if (updatePaymentLinkField?.field) {
        updatePaymentLinkField.field.action.value =
          values[CREDIT_CARD_FIELDS.maskedCardNumber] === PAYPAL_VALUE
            ? SHORTEN_FLOW_PAYMENT_SCREENS.paymentPaypalShorten
            : SHORTEN_FLOW_PAYMENT_SCREENS.paymentCardShorten;
      }

      // ***Update contact Info block***
      // Update email data
      const emailField = getFieldData(this.screen.fields, FIELD_NAMES.email);
      if (emailField.field) {
        emailField.field.title = values.email ?? emailField.field.title;
      }

      // Update Primary Phone data
      const primaryPhoneField = getFieldData(
        this.screen.fields,
        FIELD_NAMES.primaryPhone
      );
      if (primaryPhoneField.field) {
        primaryPhoneField.field.title = getLabeledText(
          primaryPhoneField.field.title,
          getOtherPhoneNumber(
            values,
            FIELD_NAMES.phoneNumber,
            FIELD_NAMES.otherPhoneNumber
          )
        );
      }

      // Update Alternative Phone data
      const alternatePhoneField = getFieldData(
        this.screen.fields,
        FIELD_NAMES.alternatePhoneNumber
      );
      if (alternatePhoneField.field) {
        alternatePhoneField.field.title = getLabeledText(
          alternatePhoneField.field.title,
          values.alternate_phone_number?.length
            ? values.alternate_phone_number
            : TEXT_NOTIFICATION_VALUES.off
        );
        const params = alternatePhoneField.field.params.split("|");
        if (values.alternate_phone_number) {
          alternatePhoneField.field.params = params
            .filter(param => param !== FIELD_PARAMS.fieldOptionHidden)
            .join("|");
        }
      }

      // Update Automatic call Phone data
      const autoCallPhoneField = getFieldData(
        this.screen.fields,
        FIELD_NAMES.automatedCall
      );
      if (autoCallPhoneField.field) {
        const optionAutoCallPhone =
          this.screen.data?.text_notification_collection?.find(
            option => option.value === values[FIELD_NAMES.automatedCall]
          );

        if (optionAutoCallPhone) {
          autoCallPhoneField.field.title = getLabeledText(
            autoCallPhoneField.field.title,
            optionAutoCallPhone.text
          );
        } else {
          const autoCallPhoneValue = getOtherPhoneNumber(
            values,
            FIELD_NAMES.automatedCall,
            FIELD_NAMES.automatedCallOther
          );
          autoCallPhoneField.field.title = getLabeledText(
            autoCallPhoneField.field.title,
            autoCallPhoneValue === TEXT_NOTIFICATION_VALUES.doNotContact
              ? TEXT_NOTIFICATION_VALUES.off
              : autoCallPhoneValue
          );
        }
      }

      // Update Text Notification Phone data
      const textNotificationField = getFieldData(
        this.screen.fields,
        FIELD_NAMES.textNotification
      );
      if (textNotificationField.field) {
        const optionTextNotification =
          this.screen.data?.text_notification_collection?.find(
            option => option.value === values.text_notification
          );
        if (optionTextNotification) {
          textNotificationField.field.title = getLabeledText(
            textNotificationField.field.title,
            optionTextNotification.text
          );
        } else {
          const textNotificationValue = getOtherPhoneNumber(
            values,
            FIELD_NAMES.textNotification,
            FIELD_NAMES.textNotificationOther
          );
          textNotificationField.field.title = getLabeledText(
            textNotificationField.field.title,
            textNotificationValue === TEXT_NOTIFICATION_VALUES.doNotContact
              ? TEXT_NOTIFICATION_VALUES.off
              : textNotificationValue
          );
        }
      }
    }
  }

  internationalizeFieldByUrlValues(name) {
    const {
      values,
      settings: { translations }
    } = this.appData;

    if (values.hasOwnProperty(name)) {
      const field = this.screen.fields.find(f => f.name === name);

      if (field) {
        field.text = localizeString(values[name], translations);
      }
    }
  }
}

export default ConsultationConfirmationViewController;
